<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup" :title="'CADASTRO DE FUNCIONÁRIO'" :showClearButton="!editMode" :showSaveButton="true"
      :showBackButton="true" v-on:Clear="onClear" v-on:Back="onBack" v-on:Save="onSave">

      <div class="form-group row pb-3">

        <div class="col-md-6">
          <label for="txtName"><small v-show="document.required" class="text-danger">*</small> Número do
            documento:</label>
          <div class="input-group">
            <b-form-input autofocus type="text" :placeholder="'Digite o número do documento'"
              v-model="document.value" v-mask="['###.###.###-##', '##.###.###/####-##']"
              :required="document.required" :state="document.state"
              :disabled="editMode"  @input="onChangeInput"></b-form-input>
          </div>
        </div>
      </div>

      <div class="form-group row pb-3">

        <div class="col-md-6">
          <label for="txtName"><small v-show="form.pessoa.nome.required" class="text-danger">*</small> Nome
            Completo:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o Nome Completo'" v-model="form.pessoa.nome.value"
              :size="form.pessoa.nome.maxlength" :required="form.pessoa.nome.required"
              :state="form.pessoa.nome.state" :disabled="alreadyAPerson"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtName"><small></small> Apelido:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite um Apelido'" v-model="form.apelido.value"
              :size="form.apelido.maxlength" :required="form.apelido.required"
              :state="form.apelido.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtName"><small v-show="form.pessoa.dataNascimento.required" class="text-danger">*</small> Data
            de Nascimento:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'DD/MM/AAAA'" v-model="form.pessoa.dataNascimento.value"
              v-mask="form.pessoa.dataNascimento.mask" :required="form.pessoa.dataNascimento.required"
              :state="form.pessoa.dataNascimento.state" :disabled="alreadyAPerson"></b-form-input>
          </div>
        </div>

      </div>

      <div class="form-group row pb-3">

        <div class="col-md-4">
          <label for="txtName"><small v-show="form.pessoa.tipoPessoa.required" class="text-danger">*</small> Tipo
            Pessoa:</label>
          <div class="input-group">
            <b-form-select v-model="form.pessoa.tipoPessoa.value" :options="form.pessoa.tipoPessoa.options"
              :disabled="alreadyAPerson || editMode">
              <template slot="first">
                <option :value="''">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>

        <div class="col-md-8">
          <label for="txtName"><small v-show="form.pessoa.emailCorporativo.required" class="text-danger">*</small>
            E-mail Corporativo:</label>
          <div class="input-group">
            <b-form-input type="email" :placeholder="'Digite o E-mail Corporativo'" v-model="form.pessoa.emailCorporativo.value"
              :size="form.pessoa.emailCorporativo.maxlength" :required="form.pessoa.emailCorporativo.required"
              :state="form.pessoa.emailCorporativo.state" :disabled="alreadyAPerson"></b-form-input>
          </div>
        </div>

      </div>

      <div class="border p-3 mb-3 " v-for="(telefone, index) in formTelefone" :key="index + 'telefone'">
        <div class="form-group row">

          <div class="col-md-4">
          <label for="txtName"><small v-show="telefone.tipoContato.required" class="text-danger">* </small>Tipo
            telefone:</label>
          <div class="input-group">
            <b-form-select v-model="telefone.tipoContato.value" :options="telefone.tipoContato.options"
              :disabled="alreadyAPerson">
              <template slot="first">
                <option :value="''">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>

        <div class="col-md-6">
          <label for="txtName"><small v-show="telefone.telefone.required" class="text-danger">*</small>
            Telefone:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'Digite o número de telefone'" v-model="telefone.telefone.value"
              v-mask="['(##) ####-####', '(##) #####-####']" :required="telefone.telefone.required"
              :state="telefone.telefone.state" :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

          <div class="col-md-1 mt-4" style="align-self: center;">
            <i v-if="!alreadyAPerson" v-on:click="onDeleteTelefone(telefone)"
            class="fa fa-trash text-danger icone-grid" v-b-tooltip.hover :title="'Clique para remover o telefone'"></i>
          </div>

        </div>
      </div>

      <div class="col-md-2 pb-4" v-if="!alreadyAPerson">
        <button type="button" class="btn btn-third btn-sm" v-on:click="onCreateNewTelefoneForm()" v-b-tooltip.hover><i
            class="fas fa-plus"></i> <span class="d-md-down-none"> Adicionar Telefone</span></button>
      </div>
      <br>

      <div v-for="(endereco, index) in formEndereco" :key="index" class="border p-3 mb-3">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="txtName"><small v-show="endereco.cep.required" class="text-danger">*</small> CEP:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'Digite o CEP'" v-model="endereco.cep.value" v-mask="'#####-###'"
                :required="endereco.cep.required" :state="endereco.cep.state" @change="(onSearchCep(endereco.cep.value, index))"
                :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

          <div class="col-md-6">
            <label for="txtName"><small v-show="endereco.endereco.required" class="text-danger">*</small>
              Endereço:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'Digite o endereço'" v-model="endereco.endereco.value"
                :size="endereco.endereco.maxlength" :required="endereco.endereco.required"
                :state="endereco.endereco.state" :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

          <div class="col-md-2">
            <label for="txtName"><small v-show="endereco.numero.required" class="text-danger">*</small> Número:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'Nº'" v-model="endereco.numero.value"
                :size="endereco.numero.maxlength" :required="endereco.numero.required" :state="endereco.numero.state"
                :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

        </div>

        <div class="form-group row">

          <div v-if="false" class="col-md-2">
            <label for="txtName"><small v-show="endereco.tipoLogradouro.required" class="text-danger">*</small> Tipo
              Logradouro:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'Digite o tipo do logradouro'"
                v-model="endereco.tipoLogradouro.value" :size="endereco.tipoLogradouro.maxlength"
                :required="endereco.tipoLogradouro.required" :state="endereco.tipoLogradouro.state"
                :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

          <div v-if="false" class="col-md-2">
            <label for="txtName"><small v-show="endereco.logradouro.required" class="text-danger">*</small>
              Logradouro:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'Digite o Logradouro'" v-model="endereco.logradouro.value"
                :size="endereco.logradouro.maxlength" :required="endereco.logradouro.required"
                :state="endereco.logradouro.state" :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

          <div class="col-md-3">
            <label for="txtName"><small v-show="endereco.complemento.required" class="text-danger">*</small>
              Complemento:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'Digite o Complemento'" v-model="endereco.complemento.value"
                :size="endereco.complemento.maxlength" :required="endereco.complemento.required"
                :state="endereco.complemento.state" :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

          <div class="col-md-3">
            <label for="txtName"><small v-show="endereco.bairro.required" class="text-danger">*</small> Bairro:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'Digite o Bairro'" v-model="endereco.bairro.value"
                :size="endereco.bairro.maxlength" :required="endereco.bairro.required" :state="endereco.bairro.state"
                :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

          <div class="col-md-2">
            <label for="txtName"><small v-show="endereco.uf.required" class="text-danger">*</small> UF:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'UF'" v-model="endereco.uf.value"
                :maxlength="endereco.uf.maxlength" :required="endereco.uf.required" :state="endereco.uf.state"
                :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

          <div class="col-md-3">
            <label for="txtName"><small v-show="endereco.municipio.required" class="text-danger">*</small>
              Município:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="'Digite o Município'" v-model="endereco.municipio.value"
                :size="endereco.municipio.maxlength" :required="endereco.municipio.required"
                :state="endereco.municipio.state" :disabled="alreadyAPerson"></b-form-input>
            </div>
          </div>

          <div class="col-md mt-4" style="align-self: center;">
            <i v-if="!alreadyAPerson" v-on:click="onDeleteEndereco(endereco)"
              class="fa fa-trash text-danger icone-grid" v-b-tooltip.hover
              :title="'Clique para remover o endereço'"></i>
          </div>

        </div>
      </div>

      <div class="col-md-2 pb-4" v-if="!alreadyAPerson">
        <button type="button" class="btn btn-third btn-sm" v-on:click="onCreateNewEnderecoForm()" v-b-tooltip.hover><i
            class="fas fa-plus"></i> <span class="d-md-down-none"> Adicionar Endereco</span></button>
      </div>

      <div v-if="false" class="form-group row pb-3">

        <div class="col-md-3">
          <label for="txtName"><small v-show="form.pessoa.contaCorrente.required" class="text-danger">*</small> Conta
            Corrente:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Número Conta Corrente'"
              v-model="form.pessoa.contaCorrente.value" :size="form.pessoa.contaCorrente.maxlength"
              :required="form.pessoa.contaCorrente.required" :state="form.pessoa.contaCorrente.state"
              :disabled="alreadyAPerson"></b-form-input>
          </div>
        </div>

        <div class="col-md-3">
          <label for="txtName"><small v-show="form.pessoa.contaCapital.required" class="text-danger">*</small> Conta
            Capital:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Número Conta Capital'" v-model="form.pessoa.contaCapital.value"
              :size="form.pessoa.contaCapital.maxlength" :required="form.pessoa.contaCapital.required"
              :state="form.pessoa.contaCapital.state" :disabled="alreadyAPerson"></b-form-input>
          </div>
        </div>

      </div>

      <div class="form-group row pb-3">

        <div class="col-md-3">
          <label for="txtName"><small v-show="form.matricula.required" class="text-danger">*</small> Número de
            matrícula:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Número de matrícula'" v-model="form.matricula.value"
              :size="form.matricula.maxlength" :required="form.matricula.required"
              :state="form.matricula.state"></b-form-input>
          </div>
        </div>

        <div class="col-md-4">
          <label for="txtName"><small v-show="form.cargoId.required" class="text-danger">*</small> Cargo:</label>
          <div class="input-group">
            <v-select v-model="form.cargoId.value" :options="form.cargoId.options" class="w-100" label="text"
              :reduce="(opt) => opt.value">
              <template v-slot:no-options>Nenhum cargo encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>

      <div v-if="!editMode" class="d-flex" style="justify-content: end; align-items: start; gap: 1rem; cursor:pointer;" @click="toggleCreateUser">
        <ToogleSwitch :value="createUser"/>
        <h5 style="line-height: 100%">Criar Usuário</h5>
      </div>

      <!-- <div class="form-group row pt-2">
        <div class="col-md-6">
          <label><small class="text-danger">*</small> Criar um usuário:</label>
          <div class="input-group">
            <b-form-select v-model="createUser">
              <template slot="first">
                <option :value="true">SIM</option>
                <option :value="false">NÃO</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div> -->

      <div v-if="createUser" class="border p-3 mt-4">
        <h4 class="mb-4"><i class="fas fa-user"></i> Novo Usuário</h4>
        <div class="form-group row pt-2">
          <div class="col-md-6">
            <label><small v-show="form.usuario.mfaActive.required" class="text-danger">*</small> MFA:</label>
            <div class="input-group">
              <b-form-select v-model="form.usuario.mfaActive.value" :options="form.usuario.mfaActive.options">
                <template slot="first">
                  <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                  <option :value="true">SIM</option>
                  <option :value="false">NÃO</option>
                </template>
              </b-form-select>
            </div>
          </div>
        </div>

        <div class="form-group row pt-2">
          <div class="col-md-6">
            <label for="txtName"><small v-show="form.usuario.username.required" class="text-danger">*</small>
              {{ $lang.Accounts.LabelLogin }}:</label>
            <div class="input-group">
              <b-form-input type="text" :placeholder="$lang.Accounts.PlaceholderEnterLogin"
                v-model="form.usuario.username.value" :size="form.usuario.username.maxlength"
                :required="form.usuario.username.required" :state="form.usuario.username.state"
                :disabled="form.usuario.username.disabled"></b-form-input>
            </div>
          </div>
          <div class="col-md-6">
            <label for="txtEmail"><small v-show="form.usuario.administrador.required" class="text-danger">*</small>
              {{ $lang.Accounts.LabelAdministrator }}:</label>
            <div class="input-group">
              <b-form-select v-model="form.usuario.administrador.value" :options="form.usuario.administrador.options">
                <template slot="first">
                  <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                  <option :value="true">SIM</option>
                  <option :value="false">NÃO</option>
                </template>
              </b-form-select>
            </div>
          </div>
        </div>

        <div class="form-group row pt-2 mb-3">
          <div class="col-md-6">
            <label for="permissionSelect"> Permissões:</label>
              <v-select
                multiple
                v-model="form.usuario.permissoes.value"
                :options="form.usuario.permissoes.options"
                :reduce="option => option.value"
                class="w-100"
                label="name"
                >
                <option :value="null">teste</option>
                <template v-slot:no-options>Nenhum Funcionário encontrado.</template>
              </v-select>
          </div>
        </div>

        <PermissionsTable @UpdatePermissionList="updatePermissionList"></PermissionsTable>

        <div class="form-group row">
          <div class="col-md-12 pt-1">
            <h5 class="text-third"><i class="fa fa-lock"></i> {{ $lang.Accounts.AccessPasswords }}</h5>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-6">
            <label for="txtPassword"><small class="text-info">*</small> {{ $lang.Accounts.LabelPassword }}:</label>
            <div class="input-group">
              <span class="input-group-addon"><i class="fa fa-lock"></i></span>
              <b-form-input type="password" :placeholder="$lang.Accounts.PlaceholderEnterPassword"
                v-model="form.usuario.password.value" :size="form.usuario.password.maxlength"
                :required="form.usuario.password.required" :state="form.usuario.password.state"
                autocomplete="new-password" @input="validatePassword(form.usuario.password.value)"></b-form-input>
            </div>
          </div>
          <div class="col-md-6">
            <label for="txtConfirmation"><small class="text-info">*</small>
              {{ $lang.Accounts.LabelConfirmation }}:</label>
            <div class="input-group">
              <span class="input-group-addon"><i class="fa fa-lock"></i></span>
              <b-form-input type="password" :placeholder="$lang.Accounts.PlaceholderConfirmationPassword"
                v-model="form.usuario.confirmation.value" :size="form.usuario.confirmation.maxlength"
                :required="form.usuario.confirmation.required" :state="form.usuario.confirmation.state"
                autocomplete="new-password" @blur.native="onCheckPassword"></b-form-input>
            </div>
          </div>
        </div>
        <hr>
        <span style="font-weight: 700">Requisitos Mínimos:</span>
      <ul>
        <li :class="lengthValid ? 'text-success' : 'text-danger'">
          Comprimento mínimo de 8 caracteres
        </li>
        <li :class="uppercaseValid ? 'text-success' : 'text-danger'">
          Letra maiúscula
        </li>
        <li :class="lowercaseValid ? 'text-success' : 'text-danger'">
          Letra minúscula
        </li>
        <li :class="numberValid ? 'text-success' : 'text-danger'">
          Número (1 - 9)
        </li>
        <li :class="specialCharValid ? 'text-success' : 'text-danger'">
          Caractere especial (!@#$%&*()+-)
        </li>
      </ul>
    </div>
    </Forms>

  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import { debounce } from 'lodash'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

import EmployeeForm from './employee-form.js'
import TelefoneForm from './telefone-form.js'
import EnderecoForm from './endereco-form.js'
import AssociateForm from './associate-form.js'

import EmployeeModel from '@/shared/models/configurations/employeemodel.js'
import AssociateModel from '@/shared/models/configurations/associatemodel.js'
import EnderecoModel from '@/shared/models/configurations/enderecomodel.js'
import TelefoneModel from '@/shared/models/configurations/telefonemodel.js'
import UserModel from '@/shared/models/configurations/accountmodel.js'

import CepRepository from '@/shared/http/repositories/external/cep.js'
import PositionRepository from '@/shared/http/repositories/configurations/position.js'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee.js'
import PessoaEmployeeRepository from '@/shared/http/repositories/configurations/personEmployee.js'
// import AssociateRepository from '@/shared/http/repositories/business/associate'
import ManagerRepository from '@/shared/http/repositories/configurations/person.js'
import PermissionsTable from '../../../account/components/permissionEmployees/permissionsTable.vue'
import { advancedOnException } from '@/components/tools/Utils'

export default {
  name: 'EmployeeAdd',
  components: { PermissionsTable, ToogleSwitch },
  mixins: [ActionsForm],
  data () {
    return {
      pessoaId: null,
      document: { value: '', required: true, state: null },
      createUser: false,
      editMode: false,
      editPerson: null,
      alreadyAnAssociate: true,
      alreadyAPerson: true,
      data: EmployeeModel,
      form: {
        ...EmployeeForm,
        ...AssociateForm
      },
      userdata: UserModel,
      formTelefone: [],
      dataTelefone: [],
      formEndereco: [],
      dataEndereco: [],
      usersList: [],
      usersAlreadyWithPermission: [],
      lengthValid: false,
      uppercaseValid: false,
      lowercaseValid: false,
      numberValid: false,
      specialCharValid: false
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      Tools.ClearDataForms(this.form.pessoa, AssociateModel)
      Tools.ClearDataForms(this.form.usuario, UserModel)
      this.form.pessoa.tipoPessoa.value = ''
      this.formTelefone = []
      this.formEndereco = []
      this.onCreateNewTelefoneForm()
      this.onCreateNewEnderecoForm()
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onLoad () {
      this.loadCargos()
    },
    onEdit (obj) {
      this.alreadyAPerson = false
      this.editMode = true
      obj.associado = { ...obj.pessoa }
      this.document.value = obj.associado.document
      this.editPerson = obj
      this.populatePersonFields(obj.pessoa)

      if (obj.id) {
        this.data.id = obj.id
      }
      if (obj.matricula) {
        this.form.matricula.value = obj.matricula
      }
      if (obj.apelido) {
        this.form.apelido.value = obj.apelido
      }
      if (obj.cargo) {
        this.form.cargoId.value = obj.cargo.id
      }
    },
    formatDateTimeForms (obj) {
      return obj.split('T')[0].split('-').reverse().join('/')
    },
    onCreate () {
      loading.push()
      if (!this.setDataForRequest()) {
        return
      }
      if (this.alreadyAPerson) {
        PessoaEmployeeRepository.Create(this.pessoaId, this.data)
          .then((response) => {
            loading.close()
            this.$emit('Back')
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch(e => advancedOnException(e, this.$lang))
      } else {
        EmployeeRepository.Create(this.data)
          .then((response) => {
            loading.close()
            this.$emit('Back')
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch(e => advancedOnException(e, this.$lang))
      }
      loading.close()
    },
    onUpdate () {
      loading.push()
      this.setIdsToInteger()
      this.data.id = parseInt(this.data.id)
      if (this.setDataForRequest()) {
        EmployeeRepository.Update(this.data)
          .then((response) => {
            loading.close()
            this.$emit('Back')
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch(this.onException)
      }
    },
    setDataForRequest () {
      if (!this.alreadyAPerson) {
        this.setPersonData()
        this.setAddressData()
        this.setPhoneData()
        this.validateAssociateData()
        this.setDatetimeSQLFormat()
      }
      this.setMatricula()
      this.setApelido()
      this.setCargoId()
      this.setDocumentData()
      this.setUserData()
      if (this.editMode) this.setEditPersonId()
      return true
    },
    setPersonData () {
      this.form.document = this.document.value ? (this.document.value).replace(/[^a-zA-Z0-9 ]/g, '') : ''
      this.data = {
        pessoa: {
          nome: this.form.pessoa.nome.value,
          document: this.form.document.value,
          tipoPessoa: this.form.pessoa.tipoPessoa.value,
          email: this.form.pessoa.email.value,
          emailCorporativo: this.form.pessoa.emailCorporativo.value,
          dataNascimento: this.form.pessoa.dataNascimento.value
        }
      }
      this.data.pessoa.telefone = []
      this.data.pessoa.endereco = []
    },
    setAddressData () {
      for (let endereco in this.formEndereco) {
        if (!Tools.ValidateForms(this.formEndereco[endereco], this.dataEndereco[endereco], this, toast)) {
          return false
        }
        this.dataEndereco[endereco].id = parseInt(this.dataEndereco[endereco].id)
        this.data.pessoa.endereco.push(this.dataEndereco[endereco])
      }
    },
    setPhoneData () {
      for (let telefone in this.formTelefone) {
        if (!Tools.ValidateForms(this.formTelefone[telefone], this.dataTelefone[telefone], this, toast)) {
          return false
        }
        this.dataTelefone[telefone].id = parseInt(this.dataTelefone[telefone].id)
        this.data.pessoa.telefone.push(this.dataTelefone[telefone])
      }
    },
    validateAssociateData () {
      if (!Tools.ValidateForms(this.form.pessoa, this.data.pessoa, this, toast)) {
        toast.warning(self.$lang.Common.Alerts.RequiredField)
        return false
      }
    },
    setMatricula () {
      if (this.form.matricula.value) {
        this.data.matricula = this.form.matricula.value
      }
    },
    setApelido () {
      if (this.form.apelido.value) {
        this.data.apelido = this.form.apelido.value
      }
    },
    setCargoId () {
      if (this.form.cargoId.value) {
        this.data.cargoId = this.form.cargoId.value
      }
    },
    setDocumentData () {
      if (this.data.pessoa) {
        this.data.pessoa.document = this.document.value.toString().replace(/[^\d]+/g, '')
        if (!this.validateDocument(this.data.pessoa.document)) {
          return false
        }
      }
    },
    setUserData () {
      if (this.createUser) {
        this.data.usuario = this.userdata
        this.data.usuario.funcionariosPermissaoId = this.usersAlreadyWithPermission.map((x) => x.funcionario.id)

        if (!Tools.ValidateForms(this.form.usuario, this.data.usuario, this, toast)) {
          return false
        }
      }
    },
    setEditPersonId () {
      if (this.editPerson.id) {
        this.data.id = this.editPerson.id
      }
    },
    setDatetimeSQLFormat () {
      if (this.data.pessoa.dataNascimento) {
        this.data.pessoa.dataNascimento = this.data.pessoa.dataNascimento.split('/').reverse().join('-')
      }
    },
    validateDocument (document) {
      if (document.length !== 11 && document.length !== 14) {
        toast.warning('Documento inválido')
        return false
      }
      return true
    },
    setIdsToInteger () {
      for (let telefone in this.dataTelefone) {
        this.dataTelefone[telefone].id = parseInt(this.dataTelefone[telefone].id)
      }
      for (let endereco in this.dataEndereco) {
        this.dataEndereco[endereco].id = parseInt(this.dataEndereco[endereco].id)
      }
    },
    onCreateNewTelefoneForm () {
      this.formTelefone.push(new TelefoneForm())
      this.dataTelefone.push(new TelefoneModel())
    },
    onDeleteTelefone (telefone) {
      let indexOfDeletion = this.formTelefone.indexOf(telefone)
      this.formTelefone.splice(indexOfDeletion, 1)
      this.dataTelefone.splice(indexOfDeletion, 1)
    },
    onCreateNewEnderecoForm () {
      let enderecoNovo = new EnderecoForm()
      this.formEndereco.push(enderecoNovo)
      this.dataEndereco.push(new EnderecoModel())
    },
    onDeleteEndereco (endereco) {
      let indexOfDeletion = this.formEndereco.indexOf(endereco)
      this.formEndereco.splice(indexOfDeletion, 1)
      this.dataEndereco.splice(indexOfDeletion, 1)
    },
    loadCargos () {
      PositionRepository.GetAll()
        .then((response) => {
          this.form.cargoId.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onChangeInput: debounce(function () {
      let document = this.document.value ? (this.document.value).replace(/[^a-zA-Z0-9 ]/g, '') : ''
      if (document !== '' && !this.editMode) {
        if (document.length !== 14 && document.length !== 11) return
        this.checkIfAlreadyPerson(document)
      }
    }, 200),
    checkIfAlreadyPerson (document) {
      ManagerRepository.GetByDocument(document)
        .then((response) => {
          if (response.data.content.length > 0) {
            let person = response.data.content[0]
            this.pessoaId = person.id
            this.populatePersonFields(person)
          } else {
            this.onClear()
            this.setNewPersonType(document)
            this.alreadyAPerson = false
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    setNewPersonType (document) {
      this.form.pessoa.tipoPessoa.value = Tools.checkDocumentType(document)
    },
    populatePersonFields (person) {
      this.populatePersonType(person)
      this.populateBirth(person)
      this.populateAdress(person)
      this.populatePhone(person)
      this.populatePersonalInfo(person)
    },
    populatePersonalInfo (person) {
      this.data.pessoa = AssociateModel
      Tools.SetValueInForm(this.form.pessoa, this.data.pessoa, person)
    },
    populatePersonType (person) {
      let setTipoPessoa = new Set(['PJ', 'PF'])
      if (!setTipoPessoa.has(person.tipoPessoa)) {
        this.form.pessoa.tipoPessoa.value = Tools.checkDocumentType(person.document)
      }
    },
    populateBirth (person) {
      if (person.dataNascimento) {
        person.dataNascimento = this.formatDateTimeForms(person.dataNascimento)
      }
    },
    populateAdress (person) {
      this.formEndereco = []
      for (let endereco in person.endereco) {
        this.onCreateNewEnderecoForm()
        Tools.SetValueInForm(this.formEndereco[endereco], this.dataEndereco[endereco], person.endereco[endereco])
      }
    },
    populatePhone (person) {
      this.formTelefone = []

      for (let telefone in person.telefone) {
        this.onCreateNewTelefoneForm()
        Tools.SetValueInForm(this.formTelefone[telefone], this.dataTelefone[telefone], person.telefone[telefone])
      }
    },
    setAssociateDataOnForms (obj) {
      this.data.pessoa = AssociateModel
      if (obj.pessoa.dataNascimento) {
        obj.pessoa.dataNascimento = this.formatDateTimeForms(obj.pessoa.dataNascimento)
      }
      Tools.SetValueInForm(this.form.pessoa, this.data.pessoa, obj.pessoa)
      for (let endereco in obj.endereco) {
        this.onCreateNewEnderecoForm()
        Tools.SetValueInForm(this.formEndereco[endereco], this.dataEndereco[endereco], obj.endereco[endereco])
      }
      for (let telefone in obj.telefone) {
        this.onCreateNewTelefoneForm()
        Tools.SetValueInForm(this.formTelefone[telefone], this.dataTelefone[telefone], obj.telefone[telefone])
      }
      let setTipoPessoa = new Set(['PJ', 'PF'])
      if (!setTipoPessoa.has(obj.tipoPessoa)) {
        this.form.pessoa.tipoPessoa.value = Tools.checkDocumentType(obj.pessoa.document)
      }
      this.form.pessoa.numSisbr.value = parseInt(this.form.pessoa.numSisbr.value)
    },
    validatePassword (password) {
      this.lengthValid = password.length >= 8
      this.uppercaseValid = /[A-Z]/.test(password)
      this.lowercaseValid = /[a-z]/.test(password)
      this.numberValid = /\d/.test(password)
      this.specialCharValid = /[!@#$%&*()+-]/.test(password)
    },
    onCheckPassword () {
      const password = this.form.usuario.password.value
      const confirmation = this.form.usuario.confirmation.value

      if (!password) {
        return
      }

      const minLength = 8
      const hasUppercase = /[A-Z]/.test(password)
      const hasLowercase = /[a-z]/.test(password)
      const numberValid = /\d/.test(password)
      const specialCharValid = /[!@#$%&*()+-]/.test(password)

      if (password.length < minLength) {
        toast.warning('ATENÇÃO! A senha deve conter no mínimo 8 caracteres')
        this.resetPasswordFields()
        return
      }

      if (!hasUppercase || !hasLowercase || !numberValid || !specialCharValid) {
        toast.warning(
          'ATENÇÃO! A senha precisa ter no mínimo um caractere:<br><ul><li>Letra Maiúscula</li><li>Letra Minúscula</li><li>Número (1 - 9)</li><li>Especial (!@#$)</li></ul>'
        )
        this.resetPasswordFields()
        return
      }

      if (confirmation && password !== confirmation) {
        toast.warning(
          'ATENÇÃO! A senha e sua confirmação não são iguais. Verifique e informe novamente, por favor'
        )
        this.resetPasswordFields()
      }
    },
    resetPasswordFields () {
      this.form.usuario.password.value = ''
      this.form.usuario.confirmation.value = ''
      this.lengthValid = false
      this.uppercaseValid = false
      this.lowercaseValid = false
      this.numberValid = false
      this.specialCharValid = false
    },
    updatePermissionList (leftTable, rightTable) {
      this.usersList = leftTable
      this.usersAlreadyWithPermission = rightTable
    },
    toggleCreateUser () {
      this.createUser = !this.createUser
    },
    onSearchCep (cep, index) {
      if (this.editMode) return false
      if (cep) {
        loading.push()
        CepRepository.GetCEP(cep)
          .then((response) => {
            var data = response.data
            this.$nextTick(() => {
              this.formEndereco[index].endereco.value = data.logradouro
              this.formEndereco[index].bairro.value = data.bairro
              this.formEndereco[index].municipio.value = data.localidade
              this.formEndereco[index].uf.value = data.uf
              loading.close()
            })
          })
          .catch((err) => {
            loading.close()
            this.onException(err)
          })
      }
    }
  }
}
</script>

<style scoped>
v-select {
  border-radius: 0% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/employee/components/add/employeeAdd.vue